<ion-card [ngClass]="{ 'high-z-index': bigZindex, 'no-padding': paddingZero }">
  <ion-card-header *ngIf="!hideHeader && title">
    <ion-card-title class="ion-justify-content-between">
      {{ title }}
      <ion-button
        (click)="onButtonClicked()"
        *ngIf="desktopHeaderButtonIcon || desktopHeaderButtonUrl"
        fill="clear"
      >
        <ion-icon
          *ngIf="desktopHeaderButtonIcon"
          slot="icon-only"
          [name]="desktopHeaderButtonIcon"
        ></ion-icon>

        <ion-icon
          slot="icon-only"
          *ngIf="desktopHeaderButtonUrl"
          [src]="desktopHeaderButtonUrl"
        ></ion-icon>
      </ion-button>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content [ngClass]="{ 'no-padding': paddingZero }">
    <ng-content></ng-content> </ion-card-content
></ion-card>
